import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useReconciliationReport} from '../hooks/useReconciliationReport.ts';

// FNP-535: read-only detail view of a single ChannelReconciler (Job B) run. No edit
// drawer / tools — the reconciler owns the lifecycle. Renders the run summary, the
// set-compare counts, and the top-N discrepancy details.
export const DetailPage = () => {
    const {id: reportId} = useParams();

    if (typeof reportId === 'undefined') {
        throw new Error('reportId is required parameter');
    }

    const {
        record: report,
        loading,
        isError,
        notFound,
    } = useReconciliationReport(reportId);

    if (loading) {
        return <PlatformLoader message='Loading reconciliation report...Please wait'/>;
    }

    // Never hang on the loader: once the query has settled, a missing record or an
    // error gets an explicit message rather than an indefinite spinner.
    if (isError || notFound || !report) {
        return (
            <Alert color='red' title='Reconciliation report not found'>
                No reconciliation report found for id <code>{reportId}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={report.id}
            pageNavigation={<EditPageNavigation component={report}/>}
        >
            <Stack gap='lg'>
                <Profile record={report}/>
            </Stack>
        </FormPageLayout>
    );
};
